import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'

import Header from './components/Header'
import Footer from './components/Footer'
import ScrollToTop from './components/ScrollToTop'

import HomePage from './pages/HomePage'
import ServicesPage from './pages/ServicesPage'
import ServiceDetailPage from './pages/ServiceDetailPage'
import GalleryPage from './pages/GalleryPage'
import PricingPage from './pages/PricingPage'
import AboutPage from './pages/AboutPage'
import ContactPage from './pages/ContactPage'
import NotFoundPage from './pages/NotFoundPage'
import ForbiddenPage from './pages/ForbiddenPage'

export default function App() {
  return (
    <HelmetProvider>
      <div className="flex min-h-screen flex-col bg-white text-slate-900 font-sans selection:bg-red-600 selection:text-white">
        <ScrollToTop />
        <Header />

        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/tjenester" element={<ServicesPage />} />
            <Route path="/tjenester/:slug" element={<ServiceDetailPage />} />
            <Route path="/billedgalleri" element={<GalleryPage />} />
            <Route path="/prisliste" element={<PricingPage />} />
            <Route path="/om-os" element={<AboutPage />} />
            <Route path="/kontakt" element={<ContactPage />} />
            <Route path="/403" element={<ForbiddenPage />} />
            <Route path="/404" element={<NotFoundPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </HelmetProvider>
  )
}
